import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtelierService {
  private selectedAtelierDate = new BehaviorSubject<Date>(new Date());
  private selectedAtelierTour = new BehaviorSubject<number>(null);
  private selectedAtelierTourItem = new BehaviorSubject<number>(null);

  constructor() {
    const storedDateString = localStorage.getItem('atelierDate');
    this.selectedAtelierDate = new BehaviorSubject<Date>(
      storedDateString == null ? new Date() : new Date(storedDateString)
    );
  }

  public getSelectedAtelierDateSubscribable(): BehaviorSubject<Date> {
    return this.selectedAtelierDate;
  }

  public setSelectedAtelierDate(date: Date) {
    this.selectedAtelierDate.next(date);
    localStorage.setItem('atelierDate', date.toISOString());
  }

  public getSelectedAtelierTourSubscribable(): BehaviorSubject<number> {
    return this.selectedAtelierTour;
  }

  public setSelectedAtelierTour(id: number) {
    this.selectedAtelierTour.next(id);
  }

  public getSelectedAtelierTourItemSubscribable(): BehaviorSubject<number> {
    return this.selectedAtelierTourItem;
  }

  public setSelectedAtelierTourItem(id: number) {
    this.selectedAtelierTourItem.next(id);
  }
}
